<template>
  <f7-card class="weight-calculator-card card-raised">
    <f7-card-content>
      <f7-row v-if="equipment_weight" class="pl-3"
              v-bind:class="{'border-bottom': active_weight_plates, 'pb-2': active_weight_plates, 'mb-2': active_weight_plates}">
        <!-- EQUIPMENT -->
        <f7-col width="80">
          <strong>{{ number_of_equipment }}x {{ current_equipment }}</strong>
        </f7-col>
        <f7-col width="20" class="text-align-right">
          <span>{{ equipment_weight }}kg</span>
        </f7-col>

        <!-- PLATES -->
        <!--        <f7-col class="text-align-right">-->
        <!--          <span>20kg</span>-->
        <!--        </f7-col>-->

      </f7-row>
      <f7-row v-for="weight_plates in weight_plates_array" v-show="weight_plates[1]" :key="JSON.stringify(weight_plates)">
        <!-- If the number_of_equipment = 2 (dumbbells) we show 4 columns -->
        <f7-col>
          <strong>{{ weight_plates[1] * number_of_equipment }}x {{ weight_plates[0] }}kg</strong>
        </f7-col>
        <f7-col class="text-align-right">
          {{ weight_plates[1] * parseFloat(weight_plates[0]) * number_of_equipment }}kg
        </f7-col>
      </f7-row>
      <f7-row v-if="number_of_equipment === 2">
        <f7-col class="mt-2">
          <f7-block color="blue" class="text-center text-color-blue">
            <h6 v-if="equipment === 'dumbbells_30mm' || equipment === 'dumbbells_50mm'">
              Gelijk verdelen over 4 zijdes van 2 dumbbells, restant is voor straps
            </h6>
            <h3 v-if="equipment === 'crossover_cables'">
              Gelijk verdelen over 4 pinnen van 2 pulleys
            </h3>
          </f7-block>
        </f7-col>
      </f7-row>
      <f7-row class="mt-2 pt-2 border-top">
        <f7-col>
          <em>Totaal</em>
        </f7-col>
        <f7-col class="text-align-right">
          <em>{{ last_set_weight * number_of_equipment }}kg</em>
        </f7-col>
      </f7-row>

    </f7-card-content>
    <f7-card-footer class="no-border">
      <f7-link small outline color="gray" @click="update_activity_rep_set_weight(0.125)">
        <strong>+0.125</strong>
      </f7-link>
      <f7-link small outline color="gray" @click="update_activity_rep_set_weight(0.25)">
        <strong>+0.250</strong>
      </f7-link>
      <f7-link small outline color="gray" @click="update_activity_rep_set_weight(0.5)">
        <strong>+0.500</strong>
      </f7-link>
    </f7-card-footer>
  </f7-card>
</template>

<script>

  import Utility from "../../js/utility";

  export default {
    components: {},

    props: ['activity'],

    mixins: [],

    data: function () {
      return {
        weight_plates: {},
        equipment_weight: 0,
        number_of_equipment: 1,

        number_of_plates_available: {
          20: 4,
          10: 4,
          5: 4,
          3: 12,
          2: 12,
          1: 12,
          2.5: 4,
          1.25: 4,
          0.5: 4,
          0.25: 4,
          0.125: 4,
        }
      };
    },

    computed: {
      current_equipment() {
        return this.$store.getters['activities/equipment'][this.activity.settings.equipment];
      },
      equipment() {
        return this.activity.settings.equipment;
      },
      last_set_weight() {
        if (this.activity.rep_sets.length > 0) {
          return parseFloat(this.activity.rep_sets[this.activity.rep_sets.length - 1].weight);
        }
        return 0;
      },
      weight_plates_array() {
        return Object.entries(this.weight_plates).sort((a, b) => {
          return parseFloat(a[0]) - parseFloat(b[0]);
        }).reverse();
      },
      active_weight_plates() {
        return this.weight_plates_array.filter(weight_plate => {
          return weight_plate[1] > 0;
        }).length;
      }
    },

    created() {
      //
    },

    mounted() {
      this.calculate_weights();
    },

    methods: {
      update_activity_rep_set_weight(weight) {

        let rep_sets = Utility.clone(this.activity.rep_sets);
        let next_set_index = this.activity.sets_finished;
        let last_set_index = rep_sets.length - 1;

        // When the next_set is greater than the last, we use the last.
        // Otherwise the next_set_index will update the... next set! :)
        next_set_index = (next_set_index > last_set_index) ? last_set_index : next_set_index;

        // Now we get the last completed rep_set
        let last_rep_set = this.activity.rep_sets[next_set_index];
        last_rep_set.weight = (parseFloat(last_rep_set.weight) + weight);

        // And here we update all the sets
        while (next_set_index < rep_sets.length) {
          rep_sets[next_set_index].weight = last_rep_set.weight;
          next_set_index++;
        }

        this.$store.dispatch('current_user/update_activity', {
          activity_id: this.activity.id,
          training_session_id: this.activity.training_session_id,
          rep_sets: rep_sets,
        }).then(response => {
          this.$emit('overwrite_rep_sets', rep_sets);
        });
      },
      calculate_weights() {
        this.resetWeightPlates();

        // none
        // olympic_barbell
        // ez_curl
        // weight_belt
        // lat_pulldown

        // dumbbells_30mm
        // dumbbells_50mm
        // crossover_cable
        // crossover_cables

        let calculator = 'calculate_' + this.activity.settings.equipment;
        this[calculator](1);
      },
      calculate_dumbbells_50mm() {
        // We get 2!
        this.calculate_dumbbell_50mm(2);
      },
      calculate_dumbbell_50mm(number_of_equipment = 1) {
        // First we remove the Barbell weight
        this.equipment_weight = 5;
        this.number_of_equipment = number_of_equipment;
        let weightLeft = this.last_set_weight - this.equipment_weight;
        // Then we check if we can fit 2x 20kg
        weightLeft = this.calculate_two_sides(weightLeft);

        // And then the Micro Plates as singles on a strap
        weightLeft = this.fitSingles(0.500, weightLeft);
        weightLeft = this.fitSingles(0.250, weightLeft);
        weightLeft = this.fitSingles(0.125, weightLeft);
      },

      calculate_dumbbells_30mm() {
        // We get 2!
        this.calculate_dumbbell_30mm(2);
      },
      calculate_dumbbell_30mm(number_of_equipment) {
        this.equipment_weight = 2;
        this.number_of_equipment = number_of_equipment;
        // First we remove the Barbell weight
        let weightLeft = this.last_set_weight - this.equipment_weight;

        // Since the 30mm have different plates, we use those:
        // Then we check if we can fit 2x 20kg
        weightLeft = this.fitPairs(5, weightLeft);
        weightLeft = this.fitPairs(3, weightLeft);
        weightLeft = this.fitPairs(2, weightLeft);
        weightLeft = this.fitPairs(1, weightLeft);
        weightLeft = this.fitPairs(0.5, weightLeft);
        // And then the Micro Plates
        weightLeft = this.fitSingles(0.500, weightLeft);
        weightLeft = this.fitSingles(0.250, weightLeft);
        weightLeft = this.fitSingles(0.125, weightLeft);
      },

      calculate_olympic_barbell() {
        this.number_of_equipment = 1;
        // First we remove the Barbell weight
        this.equipment_weight = 20;
        let weightLeft = this.last_set_weight - this.equipment_weight;
        // Then we check if we can fit 2x 20kg
        weightLeft = this.calculate_two_sides(weightLeft);
      },
      calculate_ez_curl() {
        this.number_of_equipment = 1;
        // First we remove the Barbell weight
        this.equipment_weight = 10;
        let weightLeft = this.last_set_weight - this.equipment_weight;
        weightLeft = this.calculate_two_sides(weightLeft);
      },
      calculate_lat_pulldown() {
        this.number_of_equipment = 1;
        this.equipment_weight = 0;
        let weightLeft = this.last_set_weight;
        weightLeft = this.calculate_two_sides(weightLeft);
      },
      calculate_crossover_cable() {
        console.log('calculate_crossover_cable')
        this.number_of_equipment = 1;
        this.equipment_weight = 0;
        let weightLeft = this.last_set_weight;
        weightLeft = this.calculate_two_sides(weightLeft);
      },
      calculate_crossover_cables() {
        console.log('calculate_crossover_cables')
        this.number_of_equipment = 2;
        this.equipment_weight = 0;
        let weightLeft = this.last_set_weight;
        weightLeft = this.calculate_two_sides(weightLeft);
      },

      calculate_none() {
        this.equipment_weight = 0;
        let weightLeft = this.last_set_weight;
        this.calculate_one_side(weightLeft);
      },
      calculate_weight_belt() {
        this.equipment_weight = 0;
        let weightLeft = this.last_set_weight;
        this.calculate_one_side(weightLeft);
      },

      /**
       * Meant for equipment that needs equal weight plates on 4 sides
       * The dumbbells and crossover cables
       */
      calculate_four_sides(weightLeft) {
        // Then we check if we can fit 2x 20kg
        weightLeft = this.fitQuadruples(20, weightLeft);
        weightLeft = this.fitQuadruples(10, weightLeft);
        weightLeft = this.fitQuadruples(5, weightLeft);
        weightLeft = this.fitQuadruples(2.5, weightLeft);
        weightLeft = this.fitQuadruples(1.25, weightLeft);
        // And then the Micro Plates, single per hand
        weightLeft = this.fitPairs(0.500, weightLeft);
        weightLeft = this.fitPairs(0.250, weightLeft);
        weightLeft = this.fitPairs(0.125, weightLeft);

        return weightLeft;
      },

      /**
       * Meant for equipment that needs equal weight plates on 2 sides
       */
      calculate_two_sides(weightLeft) {
        // Then we check if we can fit 2x 20kg
        weightLeft = this.fitPairs(20, weightLeft);
        weightLeft = this.fitPairs(10, weightLeft);
        weightLeft = this.fitPairs(5, weightLeft);
        weightLeft = this.fitPairs(2.5, weightLeft);
        weightLeft = this.fitPairs(1.25, weightLeft);
        // And then the Micro Plates
        weightLeft = this.fitPairs(0.500, weightLeft);
        weightLeft = this.fitPairs(0.250, weightLeft);
        weightLeft = this.fitPairs(0.125, weightLeft);

        return weightLeft;
      },

      /**
       * Meant for equipment that does not need equal weight plates
       * Like the weight belt or bench
       */
      calculate_one_side(weightLeft) {
        // Then we check if we can fit 2x 20kg
        weightLeft = this.fitSingles(20, weightLeft);
        weightLeft = this.fitSingles(10, weightLeft);
        weightLeft = this.fitSingles(5, weightLeft);
        weightLeft = this.fitSingles(2.5, weightLeft);
        weightLeft = this.fitSingles(1.25, weightLeft);
        // And then the Micro Plates
        weightLeft = this.fitSingles(0.500, weightLeft);
        weightLeft = this.fitSingles(0.250, weightLeft);
        weightLeft = this.fitSingles(0.125, weightLeft);

        return weightLeft;
      },


      /*
       |--------------------------------------------------------------------------
       | Weight CalculatorHelpers
       |--------------------------------------------------------------------------
       |
       |
       |
       |
       */
      fitSingles(weightOfPlate, weightLeft) {
        return this.fit(weightOfPlate, 1, weightLeft);
      },
      fitPairs(weightOfPlate, weightLeft) {
        return this.fit(weightOfPlate, 2, weightLeft);
      },
      fitQuadruples(weightOfPlate, weightLeft) {
        return this.fit(weightOfPlate, 4, weightLeft);
      },
      fit(weightOfPlate, times, weightLeft) {
        // Here we double the weight (pairs) and then check how many we can fit
        let fits = Math.floor((weightLeft / (weightOfPlate * times)));
        // console.log(weightOfPlate, pairs)
        // If it's more than one, we continue
        if (fits >= 1) {
          let amountOfPlatesThatFit = (fits * times);
          // Check if the amount that will fit, isn't more than the amount we have. If it is, we limit it
          // And we have to take into account the number of equipment as well.
          // Dividing it by 2 if we have 2 dumbbells for instance
          if (amountOfPlatesThatFit * this.number_of_equipment > this.number_of_plates_available[weightOfPlate]) {
            amountOfPlatesThatFit = this.number_of_plates_available[weightOfPlate] / this.number_of_equipment;
          }

          // Here we add the amount of pairs * 2, as that's the amount of plates we need
          this.weight_plates[weightOfPlate] = this.weight_plates[weightOfPlate] + amountOfPlatesThatFit;
          // And subtract that from the weight left
          weightLeft = weightLeft - (amountOfPlatesThatFit * weightOfPlate);
        }
        return weightLeft;
      },
      resetWeightPlates() {
        this.weight_plates = {
          '20': 0,
          '10': 0,
          '5': 0,
          '3': 0,
          '2': 0,
          '2.5': 0,
          '1.25': 0,
          '1': 0,
          '0.5': 0,
          '0.25': 0,
          '0.125': 0,
        };
      }
    },

    watch: {
      // If these change, we want to recalculate
      last_set_weight(value) {
        this.calculate_weights();
      },
      current_equipment(value) {
        this.calculate_weights();
      }
    }
  };
</script>
<style>
  /*@import '../../css/variables.scss';*/
</style>
